// extracted by mini-css-extract-plugin
export default {"overlay":"xbcjDaQJkCgdCNn8_AF_","overlayDashboardView":"hE140eX1buNp7GqDQB5h"};